import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';

import { ViewWrapper } from 'components/partials/insight-modal/shared/components';
import {
  TitleField,
  DescriptionField,
} from 'components/partials/insight-modal/shared/form-fields';
import type { InsightFormValues } from 'components/partials/insight-modal/shared/form-fields';

import { setMetadata as setMetadataAction } from 'state/insight/insight.slice';

import type { InsightModalMetadata } from 'components/partials/insight-modal/shared/constants';

interface InsightDetailsFormProps {
  initialMetadata?: InsightModalMetadata;
}

const InsightDetailsForm = ({ initialMetadata }: InsightDetailsFormProps) => {
  const dispatch = useDispatch();

  const { control, watch } = useForm<InsightFormValues>({
    defaultValues: {
      title: initialMetadata?.title || '',
      description: initialMetadata?.description || '',
    },
  });

  const title = watch('title');
  const description = watch('description');

  useEffect(() => {
    dispatch(
      setMetadataAction({
        reportActivePage: initialMetadata?.reportActivePage,
        reportFilters: initialMetadata?.reportFilters,
        reportId: initialMetadata?.reportId,
        relatedGoals: initialMetadata?.relatedGoals,
        source: initialMetadata?.source,
        name: initialMetadata?.name,
        isReport: initialMetadata?.isReport,
        clientId: initialMetadata?.clientId,
        title,
        description,
      })
    );
  }, [
    dispatch,
    title,
    description,
    initialMetadata?.reportActivePage,
    initialMetadata?.reportFilters,
    initialMetadata?.reportId,
    initialMetadata?.relatedGoals,
    initialMetadata?.source,
    initialMetadata?.name,
    initialMetadata?.isReport,
    initialMetadata?.clientId,
  ]);

  return (
    <ViewWrapper>
      <div className="text-navy-800 font-bold text-xl mb-6">
        Insight details
      </div>

      <TitleField
        control={control}
        label="Insight title"
        placeholder="Use this area to leave a note..."
      />

      <DescriptionField control={control} />
    </ViewWrapper>
  );
};

export default InsightDetailsForm;
